import {
    AGREEMENTS_FACILITY_CODES_ELEMENT_ID,
    AGREEMENTS_RECORD_TYPE_ALL_VALUE,
} from '../../../agreements/agreements.constants';
import {
    REPORT_RECORD_COUNT_DEFAULT_VALUE,
    REPORT_RECORD_COUNT_ELEMENT_ID,
    REPORT_RECORD_COUNT_SELECT_OPTIONS,
} from '../../../agreements/report-record-count.constants';
import type {
    ReportFilterFieldSpec,
    ReportingTargetFilterDefinition,
} from '../reporting-target-filter.types';

const AGREEMENTS_TARGET_FIELDS: readonly ReportFilterFieldSpec[] = [
    {
        elementId: REPORT_RECORD_COUNT_ELEMENT_ID,
        label: 'Record Count',
        kind: 'select',
        defaultValue: REPORT_RECORD_COUNT_DEFAULT_VALUE,
        options: REPORT_RECORD_COUNT_SELECT_OPTIONS,
    },
    {
        elementId: 'filter-expire-date-from',
        label: 'Expires before',
        kind: 'date',
        optional: true,
    },
    {
        elementId: AGREEMENTS_FACILITY_CODES_ELEMENT_ID,
        label: 'Facility Codes',
        kind: 'multiselect',
        optional: true,
        placeholder: 'Select facility codes',
        /** Options are filled from Get-UserInfo when the task pane renders filters. */
        options: [],
        visibleSize: 6,
    },
];

/**
 * Reporting target: Agreements — must match `<option value="...">` in `taskpane.html`.
 */
export const agreementsReportingTargetDefinition: ReportingTargetFilterDefinition = {
    targetId: 'agreements',
    displayName: 'Agreements',
    fetchImplemented: true,
    commonFilterFields: [],
    targetFilterFields: AGREEMENTS_TARGET_FIELDS,
    /** Inbound = 0, outbound = 1 — Get-Agreements `agreementType` (same numeric values as web `OperationType`). Omit when “All types”. */
    recordTypeFilter: {
        options: [
            { value: AGREEMENTS_RECORD_TYPE_ALL_VALUE, label: 'All types' },
            { value: '0', label: 'Inbound' },
            { value: '1', label: 'Outbound' },
        ],
        defaultValue: '1',
        payloadBinding: 'agreementType',
    },
};
